// This service handles fetching judges and assigning them to categories by the admin.
import { db } from '../firebase';
import {
  collection,
  getDocs,
  doc,
  updateDoc,
  arrayUnion,
  arrayRemove,
} from 'firebase/firestore';

// Fetch all judges
export const getJudges = async () => {
  const snapshot = await getDocs(collection(db, 'users'));
  return snapshot.docs
    .filter((doc) => doc.data().userType === 'judge')
    .map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
};

// Assign one category to a judge
export const assignJudgeToMultipleCategories = async (
  judgeId: string,
  categoryIds: string[]
): Promise<void> => {
  try {
    // 1. Update each category to include the judge
    for (const categoryId of categoryIds) {
      const categoryRef = doc(db, 'categories', categoryId);
      await updateDoc(categoryRef, {
        assignedJudgeIds: arrayUnion(judgeId),
      });
    }

    // 2. Update the judge’s document to include all category IDs
    const judgeRef = doc(db, 'users', judgeId);
    await updateDoc(judgeRef, {
      assignedCategory: arrayUnion(...categoryIds),
    });

    console.log(
      'Successfully assigned judge to categories and updated judge doc.'
    );
  } catch (err) {
    console.error('Failed to assign judge to categories:', err);
    throw err;
  }
};

// Unassign a judge from a category

export const unassignJudgeFromCategories = async (
  judgeId: string,
  categoryIds: string[]
): Promise<void> => {
  try {
    for (const categoryId of categoryIds) {
      const categoryRef = doc(db, 'categories', categoryId);
      await updateDoc(categoryRef, {
        assignedJudgeIds: arrayRemove(judgeId),
      });
    }
    console.log('Successfully unassigned judge from categories.');
  } catch (err) {
    console.error('Failed to unassign judge:', err);
    throw err;
  }
};
